export const settingsTypes = {
  SET_LOCALE: "SET_LOCALE",
};
